export default {
    meta: {
        title: {
            id: 'layout.meta.title'
        },
        description: {
            id: 'layout.meta.description'
        }
    },
    sidebar: {
        labels: {
            currentVersion: {
                id: 'layout.sidebar.labels.currentVersion'
            },
            releaseDate: {
                id: 'layout.sidebar.labels.releaseDate'
            },
            seeChangeLog: {
                id: 'layout.sidebar.labels.seeChangeLog'
            },
            backToGCO: {
                id: 'layout.sidebar.labels.backToGCO'
            }
        }
    }
};
